import ResponsiveTools from './responsiveTools';

const AppResponsiveTools = new ResponsiveTools('irobot-embedded-product-demo');

export default AppResponsiveTools;
